interface InfoQuestion {
  question: string;
  options: string[];
}

export const INFO_COLLECTION_QUESTIONS: InfoQuestion[] = [
  {
    question: "How old are you?",
    options: [
      "10-19",
      "20-29",
      "30-39",
      "40-49",
      "50-59",
      "60-69",
      "70-79",
      "80-89",
      "90+"
    ]
  },
  {
    question: "How do you identify?",
    options: [
      "Male",
      "Female",
      "Other"
    ]
  },
  {
    question: "Are you married?",
    options: [
      "Yes",
      "No"
    ]
  },
  {
    question: "How many children or dependents do you have?",
    options: [
      "0",
      "1-2",
      "3-4",
      "5+"
    ]
  },
  {
    question: "How do you earn money?",
    options: [
      "Self-Employed",
      "W2 (Salary)",
      "Other"
    ]
  },
  {
    question: "Roughly how much do you own in assets?",
    options: [
      "$1-$24,999",
      "$25,000 - $49,999",
      "$50,000 - $99,999",
      "$100,000 - $249,999",
      "$250,000 - $499,999",
      "$500,000 - $749,999",
      "$750,000 - $999,999",
      "$1,000,000+"
    ]
  },
  {
    question: "And liquid assets?",
    options: [
      "$1-$24,999",
      "$25,000 - $49,999",
      "$50,000 - $99,999",
      "$100,000 - $249,999",
      "$250,000 - $499,999",
      "$500,000 - $749,999",
      "$750,000 - $999,999",
      "$1,000,000+"
    ]
  },
  {
    question: "Do you own a home?",
    options: [
      "Yes",
      "No"
    ]
  },
  {
    question: "And how much do you owe in debt?",
    options: [
      "$1-$24,999",
      "$25,000 - $49,999",
      "$50,000 - $99,999",
      "$100,000 - $249,999",
      "$250,000 - $499,999",
      "$500,000 - $749,999",
      "$750,000 - $999,999",
      "$1,000,000+"
    ]
  },
  {
    question: "What is your household annual income?",
    options: [
      "$1-$24,999",
      "$25,000 - $49,999",
      "$50,000 - $99,999",
      "$100,000 - $249,999",
      "$250,000 - $499,999",
      "$500,000 - $749,999",
      "$750,000 - $999,999",
      "$1,000,000+"
    ]
  },
  {
    question: "Monthly Expenses",
    options: [
      "$1 - $1,999",
      "$2,000 - $4,999",
      "$5,000 - $9,999",
      "$10,000 - $19,999",
      "$20,000 - $39,999",
      "$40,000+"
    ]
  },
  {
    question: "Roughly how much do you save a year?",
    options: [
      "$1-$24,999",
      "$25,000 - $49,999",
      "$50,000 - $99,999",
      "$100,000 - $249,999",
      "$250,000 - $499,999",
      "$500,000 - $749,999",
      "$750,000 - $999,999",
      "$1,000,000+"
    ]
  }
]




// - How old are you?
//     - 10-19, 20-29, 30-39, 40-49, 50-59, 60-69, 70-79, 80-89, 90+
// - How do you identify?
//     - Male, Female, Other
// - Are you married?
//     - Yes, No
// - How many children or dependents do you have?
//     - 0, 1-2, 3-4, 5+
// - How do you earn money?
//     - Self-Employed
//     - W2 (Salary)
//     - Other
// - Roughly how much do you own in assets? (Give examples)
//     - $1-$24,999
//     - $25,000 - $49,999
//     - $50,000 - $99,999
//     - $100,000 - $249,999
//     - $250,000 - $499,999
//     - $500,000 - $749,999
//     - $750,000 - $999,999
//     - $1,000,000+
// - And liquid assets?
//     - $1-$24,999
//     - $25,000 - $49,999
//     - $50,000 - $99,999
//     - $100,000 - $249,999
//     - $250,000 - $499,999
//     - $500,000 - $749,999
//     - $750,000 - $999,999
//     - $1,000,000+
// - Do you own a home?
// - And how much do you owe in debt?
//     - $1-$24,999
//     - $25,000 - $49,999
//     - $50,000 - $99,999
//     - $100,000 - $249,999
//     - $250,000 - $499,999
//     - $500,000 - $749,999
//     - $750,000 - $999,999
//     - $1,000,000+
// - What is your household annual income?
//     - $1-$24,999
//     - $25,000 - $49,999
//     - $50,000 - $99,999
//     - $100,000 - $249,999
//     - $250,000 - $499,999
//     - $500,000 - $749,999
//     - $750,000 - $999,999
//     - $1,000,000+
// - Monthly Expenses
//     - $1 - $1,999
//     - $2,000 - $4,999
//     - $5,000 - $9,999
//     - $10,000 - $19,999
//     - $20,000 - $39,999
//     - $40,000+
// - Roughly how much do you save a year?
//     - $1-$24,999
//     - $25,000 - $49,999
//     - $50,000 - $99,999
//     - $100,000 - $249,999
//     - $250,000 - $499,999
//     - $500,000 - $749,999
//     - $750,000 - $999,999
//     - $1,000,000+